import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'whToMWh'
})
export class WhToMWhPipe implements PipeTransform {

  transform(value: number): number {
    return value / 1000000;
  }

}
